import styled from 'styled-components';
import { baseVariables } from '../../styles';

const { spacers } = baseVariables;

export const Blockquote = styled.blockquote`
  margin-block: ${spacers?.spacers?.[0] ?? '0'};
  padding-block-end: ${spacers?.spacers?.[1] ?? '0.25rem'};
  color: var(--t-brand-fg-color);
  font-family: var(--t-blockquote-font-family, var(--t-base-font-family));
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.25;
`;
